(() => {
  if (window.inlightHansleyBound) return;
  window.inlightHansleyBound = true;
  const selectView = button => {
    const gallery = button.closest('[data-hansley-gallery]');
    if (!gallery) return;
    gallery.querySelectorAll('[data-hansley-panel]').forEach(panel => { panel.hidden = panel.dataset.hansleyPanel !== button.dataset.hansleyView; });
    gallery.querySelectorAll('[data-hansley-view]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    const frame = gallery.querySelector('[data-hansley-panel="video"][hidden] iframe');
    if (frame) { frame.remove(); gallery.querySelector('[data-hansley-video-placeholder]').hidden = false; }
  };
  const selectTone = button => {
    const section = button.closest('[data-hansley-tones]');
    if (!section) return;
    section.querySelectorAll('[data-hansley-tone-image]').forEach(image => {
      const active = image.dataset.hansleyToneImage === button.dataset.hansleyTone;
      image.classList.toggle('is-active', active);
      image.setAttribute('aria-hidden', String(!active));
    });
    section.querySelectorAll('[data-hansley-tone]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
  };
  const openDetails = () => {
    const id = window.location.hash.slice(1);
    if (!id) return;
    const target = document.getElementById(id);
    if (target && target.matches('.hansley-resource-list details')) target.open = true;
  };
  window.addEventListener('hashchange', openDetails);
  openDetails();
  document.addEventListener('pointerover', event => {
    if (event.pointerType !== 'mouse') return;
    const view = event.target.closest('[data-hansley-view]');
    if (view) selectView(view);
    const tone = event.target.closest('[data-hansley-tone]');
    if (tone) selectTone(tone);
  });
  document.addEventListener('focusin', event => {
    const view = event.target.closest('[data-hansley-view]');
    if (view) selectView(view);
    const tone = event.target.closest('[data-hansley-tone]');
    if (tone) selectTone(tone);
  });
  document.addEventListener('keydown', event => {
    const tone = event.target.closest('[data-hansley-tone]');
    if (!tone || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();
    const buttons = [...tone.closest('[data-hansley-tones]').querySelectorAll('[data-hansley-tone]')];
    const index = buttons.indexOf(tone);
    let next = event.key === 'ArrowLeft' ? (index + buttons.length - 1) % buttons.length : (index + 1) % buttons.length;
    if (event.key === 'Home') next = 0;
    if (event.key === 'End') next = buttons.length - 1;
    buttons[next].focus();
  });
  document.addEventListener('click', event => {
    const view = event.target.closest('[data-hansley-view]');
    if (view) selectView(view);
    const tone = event.target.closest('[data-hansley-tone]');
    if (tone) selectTone(tone);
    const anchor = event.target.closest('a[href^="#hansley-"]');
    if (anchor) {
      const target = document.getElementById(anchor.getAttribute('href').slice(1));
      if (target && target.matches('.hansley-resource-list details')) target.open = true;
    }
    const galleryLink = event.target.closest('[data-hansley-gallery-link]');
    if (galleryLink) {
      const target = [...document.querySelectorAll('[data-hansley-view]')].find(button => button.dataset.hansleyView === galleryLink.dataset.hansleyGalleryLink);
      if (target) selectView(target);
    }
    const play = event.target.closest('[data-hansley-play]');
    if (play) {
      const panel = play.closest('[data-hansley-panel]');
      panel.querySelector('[data-hansley-video-placeholder]').hidden = true;
      panel.append(panel.querySelector('template').content.cloneNode(true));
      panel.querySelector('iframe').focus();
    }
  });
})();

